function getBundleComponentsInfo() {
  const bundleComponentsInfo = document.querySelectorAll(
    "[data-bundle-component-info]"
  );
  if (bundleComponentsInfo) {
    return Array.from(bundleComponentsInfo).map((component) =>
      JSON.parse(component.textContent)
    );
  }
  return null;
}

function getForcedBundleOptions() {
  const forcedBundleOptions = document.querySelector(
    `[data-forced-bundle-options]`
  );
  if (forcedBundleOptions) {
    const jsonForcedBundleOptions = JSON.parse(forcedBundleOptions.textContent);
    return jsonForcedBundleOptions.forcedBundleOptions.map((option) => option.replaceAll(" ", "").toLowerCase());
  }
  return [];
}

function getVariantOptionsInfo(variantId) {
  const productInfo = document.querySelector(`[data-product-info]`);
  if (productInfo) {
    const jsonProductInfo = JSON.parse(productInfo.textContent);
    const variantOptions = jsonProductInfo.variants
      .find((variant) => variant.id == variantId)
      .options.map((option) => option.replaceAll(" ", "").toLowerCase());
    return variantOptions;
  }
  return null;
}

function getHalfValues() {
  return [
    ["king", "splitking", "calking", "king/calking"],
    ["queen", "full", "queen/full"],
    ["twin", "twinxl", "twin/twinxl"]
  ];
}

function getClosestBundleComponent(component, initialOptions) {
  const variants = component.variants;
  const halfValues = getHalfValues();
  let closestVariant = variants[0];
  let mostMatchingOptions = 0;
  const forcedBundleOptions = getForcedBundleOptions();
  const options = [...initialOptions, ...forcedBundleOptions];

  variants.forEach((variant) => {
    let matchingOptions = 0;
    variant.options.forEach((option) => {
      const normalizedOption = option.replaceAll(" ", "").toLowerCase();
      if (options.includes(normalizedOption)) {
        matchingOptions++;
      } else {
        const equivalentGroup = halfValues.find(group => 
          group.includes(normalizedOption)
        );
        if (
          equivalentGroup &&
          equivalentGroup.some((eq) => options.includes(eq))
        ) {
          matchingOptions += 0.5;
        }
      }
    });
    if (matchingOptions > mostMatchingOptions) {
      closestVariant = variant;
      mostMatchingOptions = matchingOptions;
    }
  });
  return closestVariant;
}

function getBundleComponentsFromParentVariant(variantId) {
  const variantOptions = getVariantOptionsInfo(variantId);
  const bundleComponentsInfo = getBundleComponentsInfo();
  const bundleComponents = bundleComponentsInfo.map((component) =>
    getClosestBundleComponent(component, variantOptions)
  );

  return bundleComponents;
}

function getBundleComponentIdsFromParentVariant(variantId) {
  if (!isBundleProduct()) return [];
  const bundleComponents = getBundleComponentsFromParentVariant(variantId);
  console.log(bundleComponents);
  return bundleComponents.map((component) => component.id);
}

function getBundleComponentAvailabilityFromParentVariant(variantId) {
  const bundleComponents = getBundleComponentsFromParentVariant(variantId);
  return bundleComponents.every((component) => component.available);
}

function isBundleProduct() {
  const bundleComponentsInfo = document.querySelectorAll(
    "[data-bundle-component-info]"
  );
  return bundleComponentsInfo.length > 0;
}

window.getBundleComponentIdsFromParentVariant =
  getBundleComponentIdsFromParentVariant;

window.getBundleComponentAvailabilityFromParentVariant =
  getBundleComponentAvailabilityFromParentVariant;

window.isBundleProduct = isBundleProduct;
